import { getAudioStream } from "@/lib/mediaRecorder";
import {
  type Dispatch,
  type SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";

export const useAudioStream = (
  audioRef: React.MutableRefObject<HTMLAudioElement | null>,
  mediaBlobUrl: string
): [MediaStream | null, Dispatch<SetStateAction<MediaStream | null>>] => {
  const sourceNodeRef = useRef<MediaElementAudioSourceNode | null>(null);
  const audioContextRef = useRef<AudioContext | null>(null);
  const [stream, setStream] = useState<MediaStream | null>(null);

  useEffect(() => {
    if (mediaBlobUrl && audioRef.current) {
      const stream = getAudioStream(audioRef, sourceNodeRef, audioContextRef);
      if (stream) {
        setStream(stream);
      }
    }
  }, [mediaBlobUrl, audioRef]);

  return [stream, setStream];
};
